import Reflux from 'reflux'

export default Reflux.createActions([
  'queryLogs', //(ip, start, end, [sensorIds], [logDevice], [logType])
  'loadNextPage',
  'setColumnOrder', //(arrayOfColKeys)
  'resetColumnOrder',
  'setColumnWidth' //(colKey, newWidth)
])
